import { useRef, useEffect } from "react";

export const usePrevious = <T>(value: T): T => {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

// Hook to track if specified value has changed from last render of a functional component
// value: Value to check for change
// ignoreChangeFromUndefined: Ignore if previous value was undefined. Usually useful to prevent change on first load when there was no previous value
// Returns: true if value has changed from last render
export const useHasChanged = <T>(value: T, ignoreChangeFromUndefined: boolean = false): boolean => {
    const prevValue = usePrevious<T>(value);
    if (ignoreChangeFromUndefined) {
        return prevValue !== undefined && prevValue !== value;
    }
    return prevValue !== value;
}
